// extracted by mini-css-extract-plugin
module.exports = {"edit-info-form":"EditInfo_edit-info-form__1bpm0","edit-info-form__mobile":"EditInfo_edit-info-form__mobile__3jUnG"};